

































import CompilationsPreview from "~/components/compilations/CompilationsPreview"
import CompilationSection from "~/components/compilations/CompilationSection"
import {getContentByCode} from "@/utils/utils";

export default {
  components: {
    CompilationsPreview,
    CompilationSection,
  },
  inject: ['$isMobile'],
  data() {
    return {
      loadedPage: false,
      pageSizeForMobile: 3
    };
  },
  computed: {
    isMobile() {
      return this.$isMobile()
    },
    currentPage () {
      return this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1
    }
  },
  watch: {
    getSections () {

    }
  },
  head() {
    const seo = this.getSeo?.data?.data || {}
    let title = seo.title
    if (title) {
      title = title.replace(/&quot;/g, '"').replace(/&lsquo;/g, '‘').replace(/&laquo;/g, '«').replace(/&raquo;/g, '»')
    }

    return {
      title: title,
      meta: [
        { hid: 'og:title', name: 'og:title', content: title },
        { hid: 'description', name: 'description', content: seo.description },
        { hid: 'og:description', name: 'og:description', content: seo.description },
        { hid: 'keywords', name: 'keywords', content: seo.keywords }
      ]
    }
  },
  methods: {
    getText(code) {
      return getContentByCode(this.getTextBlocks.data.data, code)
    },
  },
  chimera: {
    getTextBlocks () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'all-compilations',
        auto: true,
        params: {
          code: ['all-compilations'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    getSeo () {
      return {
        url: `/api/v1/seo/getByCode`,
        key: `page-seo-compilations`,
        params: {
          code: 'app-compilations',
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    getSections () {
      return {
        url: `/api/compilationsections/`,
        key: `compilationsections`,
        debounce: 1000,
        params: {
          lang: this.$i18n.locale || 'ru',
          page_size: this.isMobile ? this.pageSizeForMobile : null,
          page: this.currentPage
        },
        on: {
          success() {
            if(this.loadedPage && this.isMobile) {
              if (typeof window !== 'undefined') {
                const anchor = document.querySelector('#sectionsStart')
                this.$scrollToTop(anchor, 300, 0)
              }
            } else if(!this.loadedPage ) {
              this.loadedPage = true
            }
          }
        }
      }
    }
  }
}
